{
  "labels": {
    "aircraft": "Aéronef",
    "limitToCompleted": "Limiter aux terminés",
    "limitToNotCompleted": "Limiter aux non terminés",
    "locked": "Verrouillé?",
    "isHidden": "Masqué ?"
  },
  "buttons": {
    "new": "Nouv",
    "deploy": "Déployer"
  },
  "snackbar": {
    "staging": "Pour info - Environnement de test",
    "editingCompleted": "Vous modifiez un aéronef terminé.",
    "deploymentStarted": "Déploiement des données aéronef lancé. Suivez la progression dans Super Admin > Statut système.",
    "deploymentFailed": "Échec du déploiement"
  },
  "confirmations": {
    "lockToggle": "Tu es sûr, chef ?",
    "hiddenToggle": "Vraiment sûr ?",
    "deployTitle": "Confirmer déploiement",
    "deployText": "Voulez-vous vraiment déployer ?",
    "deployOk": "C'est parti !"
  },
  "errors": {
    "deployFailed": "Échec du déploiement des données aéronef"
  },
  "presenter": {
    "labels": {
      "topView": "Vue dessus",
      "sideView": "Vue latérale"
    },
    "buttons": {
      "removeImage": "supprimer l'image"
    }
  },
  "inputForm": {
    "labels": {
      "id": "ID",
      "make": "Créer",
      "model": "Modèle",
      "linkAircraftTo": "Associer cet aéronef à",
      "wingBottom": "Intrados",
      "wingTop": "Extrados",
      "horizontalTailBottom": "Empennage horizontal inférieur —",
      "horizontalTailTop": "Empennage horizontal haut —",
      "verticalTailBottom": "Empennage vertical bas |",
      "verticalTailTop": "Sommet de la dérive |",
      "cabinBottom": "Plancher cabine",
      "cabinTop": "Cabine haut",
      "nose": "Nez",
      "midline": "Médiane",
      "length": "Longueur",
      "wingspan": "Envergure",
      "tailHeight": "Hauteur de queue",
      "contourNumber": "Contour nº",
      "simplifyPercent": "Simplifier %",
      "bottom": "Bas",
      "top": "Haut",
      "limitDegrees": "Limiter les degrés",
      "front": "Avant",
      "rear": "Arr.",
      "tailWheel": "Roulette arr. ?",
      "fuelCapacity": "Capacité carburant",
      "fuelType": "Carburant",
      "cruiseBurn": "Conso. croisière (gal/h)",
      "cruiseSpeed": "Vitesse de croisière (kts)",
      "reserves": "Réserves (gal)",
      "cruiseAltitude": "Altitude de croisière (ft)",
      "isHelicopter": "Hélicoptère ?"
    },
    "buttons": {
      "remove": "Supprimer",
      "save": "Enregistrer",
      "noPropeller": "sans hélice",
      "select": "Choisir",
      "clear": "Effacer",
      "auto": "auto"
    },
    "sections": {
      "referencePoints": "Points de référence",
      "orientation": "Orientation",
      "propellers": "Hélices",
      "dimensions": "Dimensions",
      "outline": "Aperçu",
      "overlaps": "Conflits",
      "wings": "Ailes",
      "horizontalTail": "Queue horizontale",
      "verticalTailFin": "Dérive",
      "cabin": "Cabine",
      "towing": "Tractage",
      "fuel": "Fuel",
      "helicopter": "Hélicoptère"
    },
    "fuelTypes": {
      "jetA": "Jet A",
      "avGas": "AvGas",
      "other": "Autre"
    },
    "helperText": {
      "cruiseBurn": "Consommation de carburant de croisière typique en gallons par heure",
      "cruiseSpeed": "Vitesse vraie de croisière typique en nœuds",
      "reserves": "Réserves de carburant standards (VFR/IFR dégagement + sécurité)",
      "cruiseAltitude": "Altitude de croisière typique en pieds (ex. : 41000 pour FL410)"
    }
  }
}
